import React, { useState, useEffect } from 'react';
import { Link, useLocation, useParams } from 'react-router-dom';
import { FormPreviewModal } from '@/components/Frontend/components/FormPreviewModal';
import Loader from "@/components/Loader"
import { FrontendService } from "@/services/frontendService";
import { useNavigate } from 'react-router-dom';
import { CheckCircleIcon } from '@heroicons/react/24/solid';
import useToastStore from '@/components/Common/Toast/toastStore';
// import ApplyPopup from '@/components/Vacancies/ApplyPopup';
import { Dialog } from '@mui/material';
import { GoogleFontLoader } from '@/components/GoogleFontLoader';
import { formDataToObject, objectToFormData } from '@/utils/fordata';
import { Editor } from '@tinymce/tinymce-react';
import { isLightColor } from '@/utils/helpers';
import CampaignPrePostText from "@/components/Frontend/components/CampaignPrePostText";
import Dropdown from '@/components/ui/Dropdown';
// import GDPRConsentPopup from '@/components/Vacancies/GDPRConsentPopup';


export const TINYMCE_CONFIG = {
  height: 300,
  menubar: false,
  plugins: [
    'advlist autolink lists link image charmap print preview anchor',
    'searchreplace visualblocks code fullscreen',
    'insertdatetime media table paste code help wordcount'
  ],
  toolbar: 'bold italic underline',
  placeholder: 'Write your cover letter...'
};

function Vacancy({ vacancyData, campaignData}) {
  const location = useLocation();
  const [campaign, setCampaign] = useState(campaignData || {});
  const { vacancySlug, companySlug, campaignSlug } = useParams();
  const {showToast} = useToastStore;
  const [company, setCompany] = useState({});
  const [vacancy, setVacancy] = useState(vacancyData || {});
  const [loading, setLoading] = useState(false);
  const [submitting, setSubmitting] = useState(false);

  const [submitted_success, setSubmitSuccess] = useState(false);
  const [textColor, setTextColor] = useState('text-white');

  const navigate = useNavigate();

  const [openPopup, setOpenPopup] = useState(true);
  const [showMainForm, setShowMainForm] = useState(true);
  // const [gdprPopupOpen, setGdprPopupOpen] = useState(false);

  // Add state for dropdown values
  const [nsSecGroup, setNsSecGroup] = useState(null);
  const [schoolType, setSchoolType] = useState(null);
  // useEffect(() => {
  //   const getVacancy = async () => {
  //     if (!vacancy?.id) {
  //       const _vacancy = await FrontendService.getVacancyBySlug(null, null, vacancySlug)
   
  //       setVacancy(_vacancy || {});
  //       setCampaign(_vacancy.campaign || {});
  //       setLoading(false);
  //     }
  //   }
  //   getVacancy();
  // }, [vacancySlug]);

  useEffect(() => {
    if (campaign?.id || campaignData?.company) {
      const companyData = campaign?.company || campaignData?.company;
      setCompany(companyData);
      setTextColor(isLightColor(companyData?.brand_color) ? 'text-on-light' : 'text-on-dark');
    }
  }, [campaign, campaignData]);

  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    gender: '',
    languages: '',
    university: '',
    degree: '',
    graduationYear: '',
    fieldOfStudy: '',
    gpa: '',
    qualification: '',
    motivation: '',
    achievement: '',
    whyCompany: '',
    experience: '',
    consent: false
  });

  // Add new state for GDPR error
  // const [gdprError, setGdprError] = useState(false);

  // array of objects
  const [radioConditionalValues, setRadioConditionalValues] = useState([]);
  const [checkboxConditionalValues, setCheckboxConditionalValues] = useState([]);

  const handleSubmit = (e) => {
    e.preventDefault();
    const formData = new FormData(e.target);
    setSubmitting(true);

    // Check GDPR consent
    // const gdprConsent = formData.get('consent');
    // if (!gdprConsent) {
    //   setGdprError(true);
    //   setSubmitting(false);
    //   showToast({message: 'Please accept the GDPR consent to proceed', type: "error"});
    //   return;
    // }
    // setGdprError(false);

    // Get email and confirm email values
    const email = formData.get('email');
    const confirmEmail = formData.get('confirm_email');

    // Validate email fields
    if (!confirmEmail) {
      showToast({message: 'Please confirm your email address', type: "error"});
      setSubmitting(false);
      return;
    }

    if (email !== confirmEmail) {
      showToast({message: 'Email and Confirm Email do not match. Please double-check and try again.', type: "error"});
      setSubmitting(false);
      return;
    }

    // Add dropdown values to form data
    if (nsSecGroup) {
      formData.set('household_earner_occupation', nsSecGroup.value);
    }
    if (schoolType) {
      formData.set('secondary_school_type', schoolType.value);
    }

    // convert form data to object
    const data = formDataToObject(formData);
    // Process radio conditional values
    radioConditionalValues.forEach(cond => {
      const fieldIndex = data.fields.findIndex(f => f.vacancy_custom_field_id == cond.fieldid);
      if (fieldIndex !== -1 && data.fields[fieldIndex].field_type == 'radio') {
        data.fields[fieldIndex].field_value = `${cond.triggervlue}: ${cond.conditionalvalue}`;
      }
    });

    // Process checkbox conditional values
    checkboxConditionalValues.forEach(cond => {
      const fieldIndex = data.fields.findIndex(f => f.vacancy_custom_field_id == cond.fieldid);
      if (fieldIndex !== -1 && data.fields[fieldIndex].field_type == 'checkbox') {
        // For checkboxes, we need to handle multiple values
        const currentValue = data.fields[fieldIndex].field_value || '';
        const values = currentValue.split(',').map(v => v.trim());
        const updatedValue = values.map(v => 
          v === cond.triggervlue ? `${cond.triggervlue}: ${cond.conditionalvalue}` : v
        ).join(',');
        data.fields[fieldIndex].field_value = updatedValue;
      }
    });
  
    // console.log("Data", data)

    // Remove heading fields and field_type property
    const updatedFields = data.fields.filter(field => field.field_type !== 'heading').map(field => { delete field.field_type; return field; });
    // console.log("Updated Fields", updatedFields)

    // Add vacancy_id to the form data
    data.vacancy_id = vacancy.id;

    // Add SMS data to the payload as top-level fields
    if (vacancy?.sms) {
      data.first_gen_university = formData.get('first_gen_university');
      data.household_earner_occupation = formData.get('household_earner_occupation') || (nsSecGroup ? nsSecGroup.value : null);
      data.postcode_at_14 = formData.get('postcode_at_14');
      data.secondary_school_type = formData.get('secondary_school_type') || (schoolType ? schoolType.value : null);
      data.received_free_school_meals = formData.get('received_free_school_meals');
    }

    let updatedformData = objectToFormData({ ...data, fields: updatedFields });

  
  
    setSubmitSuccess(true);
    setSubmitting(false);
    // FrontendService.applicationSubmission(updatedformData)
    //   .then(response => {
    //     if (response.status === 201) {
    //       // navigate('/application/success', { replace: true, state: {post_text: vacancy.post_text} });
    //       setSubmitSuccess(true);
    //       // showToast({message: 'Application submitted successfully!', type: "success"});
    //     }
    //   })
    //   .catch(error => {
    //     showToast({message: error.message, type: "error"});
    //   }).finally(() => {
    //     setSubmitting(false);
    //   });
  };

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleContinueWithEmail = () => {
    setOpenPopup(false);
    setShowMainForm(true);
  };

  if (loading) {
    return <Loader />;
  }
  
  const checkCampaign = (OnlyCheckCondition=false) => {
    const currentDate = new Date();
    const startDate = new Date(campaign?.start_date + ' ' + campaign?.start_time);
    const endDate = new Date(campaign?.end_date + ' ' + campaign?.end_time);
    if(currentDate < startDate){
      if(OnlyCheckCondition){
        return true;
      }
      return <CampaignPrePostText campaign={campaign} isPreCampaign={true} />
    }
    if(currentDate > endDate){
      if(OnlyCheckCondition){
        return true;
      }
      return <CampaignPrePostText campaign={campaign} isEndCampaign={true} />
    }
    return null;
  };

  const checkVacancy = (OnlyCheckCondition=false) => {
    const currentDate = new Date().setHours(0, 0, 0, 0);
    
    if(new Date(vacancy.start_date).setHours(0, 0, 0, 0) > currentDate){
      if(OnlyCheckCondition){
        return true;
      }
      return <CampaignPrePostText campaign={campaign} vacancy={vacancy} isPreCampaign={true} isCampaign={false} />
      return <div className="w-full mx-auto p-4 text-center text-muted-foreground text-lg">
        Thank you for your interest! Applications for this position will open soon. Please check back later.
      </div>
    }
    if(new Date(vacancy.end_date).setHours(0, 0, 0, 0) < currentDate){
      if(OnlyCheckCondition){
        return true;
      }
      return <CampaignPrePostText campaign={campaign} vacancy={vacancy} isEndCampaign={true} isCampaign={false} />
      return <div className="w-full mx-auto p-4 text-center text-muted-foreground text-lg">
        Thank you for your interest, unfortunately applications have now closed for this position.
      </div>
    }
    return null;
  }


  return (
    <div
      style={{ fontFamily: company?.brand_font || 'inherit' }} className="min-h-screen p-4 microsite-content">
      {company?.brand_font && <GoogleFontLoader key={company?.brand_font} font={company.brand_font} />}

      <div className="max-w-7xl mx-auto relative">
        {loading && (
          <div className="absolute inset-0 bg-card/80 backdrop-blur-sm z-50 flex items-center justify-center">
            <Loader />
          </div>
        )}

        {(companySlug && campaignSlug) && <Link
          to={`/${companySlug}/${campaignSlug}`}
          style={{ backgroundColor: company?.brand_color || '#000' }}
          className={`inline-block  ${textColor} px-4 py-2 rounded-lg transition-colors duration-200 mb-4`}
        >
          ← View all vacancies
        </Link>}
        {checkCampaign() ?? checkVacancy()}
        {console.log("company color", campaign?.company?.brand_color)}
        <div
          style={{
            background: campaign?.company?.brand_color || '#000',
          }}
          className=" rounded-xl shadow-xl mb-12">
          <div className="p-8">
            <div className="mb-4">
              <h1 className={`text-4xl font-bold ${textColor} mb-8`}>{campaign?.company?.name}</h1>
            </div>
            <div className="bg-white/20 p-8 rounded-lg backdrop-blur-sm border border-white/20">
              <div>
                <h2 className={`text-2xl font-semibold ${textColor} mb-4`}>
                  {console.log("campaign", campaign?.title)}
                  {console.log("vacancy", vacancy?.title)}
                  {campaign?.title} - {vacancy?.title}
                </h2>
                <div className={`${textColor} text-lg leading-relaxed`} dangerouslySetInnerHTML={{ __html: vacancy?.description }} />
              </div>
              <div className="mt-6 flex flex-wrap gap-3">
                {vacancy?.vacancy_tag?.map((tag, index) => (
                  <div key={tag.id || index} className="bg-card/10 px-4 py-2 rounded-lg border border-white/20">
                    <span className={`font-medium ${textColor}`}>{tag.title}</span>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
          <div>
            <div className="rounded-3xl mb-24 w-full mx-auto p-4 bg-card flex flex-col my-">
              <div className="bg-muted p-6 rounded-xl mb-8">
                <div className="space-y-6">
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                    <div>
                      <label className="block text-foreground font-semibold mb-1">
                        Email Address <span className="text-red-500">*</span>
                      </label>
                      <span className="block text-muted-foreground text-sm -mt-0.5">We'll never share your email</span>
                      <div className="mt-1">
                        <input
                          name='email'
                          type="email"
                          placeholder="Enter your email"
                          className="w-full p-3 rounded-lg border border-border focus:outline-none focus:border-input bg-card"
                          required
                          onCopy={(e) => e.preventDefault()}
                        />
                      </div>
                    </div>

                    <div>
                      <label className="block text-foreground font-semibold mb-1">
                        Confirm Email Address <span className="text-red-500">*</span>
                      </label>
                      <span className="block text-muted-foreground text-sm -mt-0.5">Please confirm your email address</span>
                      <div className="mt-1">
                        <input
                          name='confirm_email'
                          type="email"
                          placeholder="Confirm your email"
                          className="w-full p-3 rounded-lg border border-border focus:outline-none focus:border-input bg-card"
                          required
                          onPaste={(e) => e.preventDefault()}
                        />
                      </div>
                    </div>

                    {vacancy?.resume_enable ? (
                      <div>
                        <label className="block text-foreground font-semibold mb-1">
                          {vacancy?.resume_label} <span className="text-red-500">*</span>
                        </label>
                        <span className="block text-muted-foreground text-sm -mt-0.5">PDF (max 5MB)</span>
                        <div className="mt-1">
                          <input
                            name="resume"
                            type="file"
                            accept=".pdf"
                            className="w-full p-3 rounded-lg border border-border focus:outline-none focus:border-input bg-card"
                            required
                          />
                        </div>
                      </div>
                    ) : null}
                  </div>

                  {vacancy?.cover_letter_enable ? (
                    <div>
                      <label className="block text-foreground font-semibold mb-1">
                        {vacancy?.cover_letter_label} 
                      </label>
                      <span className="block text-muted-foreground text-sm -mt-0.5">Tell us why you're interested in this position</span>
                      <div className="mt-1">
                      
                        <textarea
                          name="cover_letter"
                          placeholder="Write your cover letter..."
                          className="w-full p-3 rounded-lg border border-border focus:outline-none focus:border-input bg-card"
                          rows={10}
                          onInput={(e) => {
                            e.target.style.height = "auto";
                            e.target.style.height = `${e.target.scrollHeight}px`;
                          }}
                          value={formData.cover_letter || ""}
                          onChange={(e) => setFormData(prev => ({...prev, cover_letter: e.target.value}))}
                        />
                      </div>

                    </div>
                  ) : null}
                </div>
                
              </div>
              

              {/* social mobility questions  */}
              {(() => {
                
                return vacancy?.sms ? (
              <div className="p-6 rounded-xl mb-2">
                  <div>
                    <h2 className="block mb-6 text-xl text-foreground font-bold ">Social Mobility Questions</h2>
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                      {/* Q1 */}
                      <div className="md:col-span-2">
                        <label className="block text-foreground text-base font-semibold mb-2">
                          Are you the first generation in your family to attend university?
                        </label>
                        <div className="grid grid-cols-2 gap-4 mt-2">
                          <label className="w-full border border-border rounded-lg px-4 py-3 flex items-center cursor-pointer">
                            <input
                              type="radio"
                              name="first_gen_university"
                              value="yes"
                              className="form-radio"
                            />
                            <span className="ml-2">yes</span>
                          </label>
                          <label className="w-full border border-border rounded-lg px-4 py-3 flex items-center cursor-pointer">
                            <input
                              type="radio"
                              name="first_gen_university"
                              value="no"
                              className="form-radio"
                            />
                            <span className="ml-2">no</span>
                          </label>
                        </div>
                      </div>
                      {/* Q2 */}
                      <div>
                        <label className="block text-foreground text-base font-semibold mb-2">
                          Main household earner's occupation at age 14
                        </label>
                        <Dropdown
                          options={[
                            { label: 'Small employers & own-account', value: 'Small employers & own-account' },
                            { label: 'Lower supervisory & technical', value: 'Lower supervisory & technical' },
                            { label: 'Semi routine occupations', value: 'Semi routine occupations' },
                            { label: 'Routine occupations', value: 'Routine occupations' },
                            { label: 'Long-term unemployed / never worked', value: 'Long-term unemployed / never worked' },
                            { label: 'Higher managerial, administrative, professional', value: 'higher managerial' },
                            { label: 'Lower managerial, administrative, professional', value: 'lower_managerial' },
                            { label: 'Intermediate occupations', value: 'intermediate' }
                          ]}
                          value={nsSecGroup}
                          onChange={setNsSecGroup}
                          placeholder="Please Select Option"
                          className="mt-1 border border-input text-muted-foreground rounded-md "
                          triggerClassName="!bg-transparent"
                        />
                      </div>
                      {/* Q3 */}
                      <div>
                        <label className="block text-foreground text-base font-semibold mb-2">
                          Home postcode at age 14 (IMD/SIMD/WIMD/NIMDM decile)
                        </label>
                        <input
                          type="text"
                          name="postcode_at_14"
                          placeholder="Enter postcode"
                          className="w-full px-3 py-[12px] rounded-lg border border-border focus:outline-none focus:border-input bg-card"
                        />
                      </div>
                      {/* Q4 */}
                      <div>
                        <label className="block text-foreground text-base font-semibold mb-2">
                          Type of secondary school attended (11-16)
                        </label>
                        <Dropdown
                          options={[
                            { label: 'State non-selective (comprehensive)', value: 'state non-selective' },
                            { label: 'State selective / Grammar', value: 'state selective' },
                            { label: 'Independent / Fee-paying', value: 'independent' },
                            { label: 'Educated abroad', value: 'educated abroad' },
                          ]}
                          value={schoolType}
                          onChange={setSchoolType}
                          placeholder="Please Select Option"
                          className="mt-1 border border-input text-muted-foreground rounded-md "
                          triggerClassName="!bg-transparent"
                        />
                      </div>
                      {/* Q5 */}
                      <div className="md:col-span-2">
                        <label className="block text-foreground text-base font-semibold mb-2">
                          Did you ever receive Free School Meals?
                        </label>
                        <div className="grid grid-cols-2 gap-4 mt-2">
                          <label className="w-full border border-border rounded-lg px-4 py-3 flex items-center cursor-pointer">
                            <input
                              type="radio"
                              name="received_free_school_meals"
                              value="yes"
                              className="form-radio"
                            />
                            <span className="ml-2">yes</span>
                          </label>
                          <label className="w-full border border-border rounded-lg px-4 py-3 flex items-center cursor-pointer">
                            <input
                              type="radio"
                              name="received_free_school_meals"
                              value="no"
                              className="form-radio"
                            />
                            <span className="ml-2">no</span>
                          </label>
                        </div>
                      </div>
                    </div>
                  </div>
              </div>
            ) : null;
              })()}
              <FormPreviewModal 
                className="w-full"
                isOpen={true}
                onClose={() => { }}
                tinymceConfig={TINYMCE_CONFIG}
                formFields={[
                  ...(vacancy?.custom_fields?.personal?.map((field) => {
                    field.type = field.field_type;
                    
                    // Parse university_repeatable field JSON options
                    if (field.field_type === 'university_repeatable' && field.options) {
                      console.log('CampaignApplyForm - Processing university field:', field);
                      try {
                        let structuredOptions;
                        
                        // Handle both string and already parsed object
                        if (typeof field.options === 'string') {
                          structuredOptions = JSON.parse(field.options);
                        } else if (Array.isArray(field.options)) {
                          structuredOptions = field.options;
                        } else {
                          structuredOptions = [];
                        }
                        
                
                        
                        const fieldLabels = {};
                        let universityOptions = [], degreeOptions = [], fieldOfStudyOptions = [];

                        structuredOptions.forEach((subField, index) => {
                          if (subField.field_type === 'select') {
                            const labelLower = subField.label.toLowerCase();
                            if (index === 0 || labelLower.includes('university') || labelLower.includes('name') || labelLower.includes('institution')) {
                              fieldLabels.universityLabel = subField.label;
                              universityOptions = subField.options || [];
                            } else if (labelLower.includes('degree') || labelLower.includes('qualification') || labelLower.includes('level')) {
                              fieldLabels.degreeLabel = subField.label;
                              degreeOptions = subField.options || [];
                      
                            } else if (labelLower.includes('study') || labelLower.includes('subject') || labelLower.includes('field')) {
                              fieldLabels.fieldOfStudyLabel = subField.label;
                              fieldOfStudyOptions = subField.options || [];
                        
                            }
                                                                } else if (subField.field_type === 'number') {
                              const labelLower = subField.label.toLowerCase();
                              if (labelLower.includes('graduation') || labelLower.includes('year')) {
                                fieldLabels.graduationYearLabel = subField.label;
              
                              } else if (labelLower.includes('gpa') || labelLower.includes('grade')) {
                                fieldLabels.gpaLabel = subField.label;
                              
                              }
                            } else if (subField.field_type === 'text' || subField.field_type === 'textarea') {
                              const labelLower = subField.label.toLowerCase();
                              if (labelLower.includes('study') || labelLower.includes('subject') || labelLower.includes('field') || 
                                  labelLower.includes('course') || labelLower.includes('major') || labelLower.includes('discipline') ||
                                  labelLower.includes('programme') || labelLower.includes('program')) {
                                fieldLabels.fieldOfStudyLabel = subField.label;
                                console.log('Found field of study (text field):', subField.label);
                              }
                            }
                        });

                        field.fieldLabels = fieldLabels;
                        field.universityOptions = universityOptions;
                        field.degreeOptions = degreeOptions;
                        field.fieldOfStudyOptions = fieldOfStudyOptions;
                        
                        // Fallback: if we have a text field for field of study but no label was set, try to find it
                        if (!fieldLabels.fieldOfStudyLabel) {
                          const textField = structuredOptions.find(subField => 
                            (subField.field_type === 'text' || subField.field_type === 'textarea') &&
                            (subField.label.toLowerCase().includes('study') || 
                              subField.label.toLowerCase().includes('subject') || 
                              subField.label.toLowerCase().includes('field') ||
                              subField.label.toLowerCase().includes('course') ||
                              subField.label.toLowerCase().includes('major'))
                          );
                          if (textField) {
                            fieldLabels.fieldOfStudyLabel = textField.label;
                            console.log('Found field of study in fallback:', textField.label);
                          }
                        }
                      } catch (error) {
                        console.error('Error parsing university options in personal form:', error);
                      }
                    } else if (['select', 'checkbox', 'radio'].includes(field.field_type) && !Array.isArray(field.options)) {
                      field.options = field.options ? field.options.split(',').map(opt => opt.trim()) : [];
                    }
                    
                    field.form_type = field.form_type;
                    return field;
                  }) ?? []),
                  ...(vacancy?.custom_fields?.job?.map((field) => {
                    field.type = field.field_type;
                    if (['select', 'checkbox', 'radio'].includes(field.field_type) && !Array.isArray(field.options)) {
                      field.options = field.options ? field.options.split(',').map(opt => opt.trim()) : [];
                    }
                    
                    field.form_type = field.form_type;
                    return field;
                  }) ?? [])
                ]}
                setRadioConditionalValues={setRadioConditionalValues}
                setCheckboxConditionalValues={setCheckboxConditionalValues}
              />
              <div className="pl-6 -pt-6">
                    <div className="mb-4">
                  {/* <div className="flex items-center space-x-3">
                    <input
                      type="checkbox"
                      name="consent"
                      required
                      checked={formData.consent}
                      onChange={(e) => {
                        setFormData(prev => ({ ...prev, consent: e.target.checked }));
                        setGdprError(!e.target.checked);
                      }}
                      className="h-4 w-4 text-blue-600 border-input rounded focus:ring-blue-500 items-center"
                    />
                    <div 
                      className="text-base text-foreground cursor-pointer"
                      onClick={() => {
                        setFormData(prev => ({ ...prev, consent: !prev.consent }));
                        setGdprError(!!formData.consent);
                      }}
                    >
                      I agree to the processing of my personal data in accordance with our{' '}
                      <span 
                        className="text-blue-600 hover:underline"
                        onClick={(e) => {
                          e.stopPropagation();
                          setGdprPopupOpen(true);
                        }}
                      >
                        privacy policy
                      </span>{' '}
                      <span className="text-red-500">*</span>
                    </div>
                  </div>
                  {gdprError && (
                    <p className="text-red-500 text-sm mt-1 ml-7">
                      Please accept the GDPR consent to proceed
                    </p>
                  )} */}
                </div>
                <button
                  disabled={submitting}
                  type="submit"
                  // onClick={(event) => {event.preventDefault(); handleSubmit(event)}}
                  style={{ backgroundColor: company?.brand_color || '#000' }}
                  className={`w-full px-4 py-2 ${textColor} rounded-md focus:outline-none focus:ring-2 focus:ring-[#D3D3D3] focus:ring-offset-2 disabled:opacity-50 disabled:cursor-not-allowed`}
                >
                  {submitting ? 'Please Wait...' : 'Submit'}
                </button>
              </div>
            </div>
          </div>
      </div>
    </div>
  );
}

export default Vacancy;
